/**
 * API地址
 * @type {string}
 */
export const BASE_URL = window.BASE_URL

/**
 * VUE2项目地址
 * @type {string}
 */
export const VUE2_BASE_URL = window.VUE2_BASE_URL
/**
 * VUE3项目地址
 * @type {string}
 */
export const VUE3_BASE_URL = window.VUE3_BASE_URL

/**
 * AI配置项
 */
export const STELLAR_AI_BASE_URL = window.STELLAR_AI_BASE_URL

/**
 * PlusAI配置项
 */
export const STELLAR_PLUS_AI_BASE_URL = window.STELLAR_PLUS_AI_BASE_URL 